export function trackGa4Event({
  event = 'ga4_event',
  ga4Event = '-',
  ga4ParameterName = '-',
  ga4ParameterValue = '-',
} = {}) {
  const eventData = {}
  if (event !== '-') eventData.event = event
  if (ga4Event !== '-') eventData.ga4_event = ga4Event
  if (ga4ParameterName !== '-') eventData.ga4_parameter_name = ga4ParameterName
  if (ga4ParameterValue !== '-') eventData.ga4_parameter_value = ga4ParameterValue

  // console.log(eventData)

  if (window.dataLayer) window.dataLayer.push(eventData)
}
